import React from 'react';
import { Box } from '@mui/material';

import GridContainer from '@/components/Grid/GridContainer';
import Card from '@/components/Card/Card';
import CardBody from '@/components/Card/CardBody';

const PageLayout = ({
  children,
  header,
  height = '89vh',
  padding = { pt: 2, px: 2, pb: 4 },
  overflow = 'hidden',
  noCard = false,
}) => {
  return (
    <Box
      sx={{
        height,
        overflow,
        ...padding,
      }}>
      <GridContainer>
        {noCard ? (
          <>
            {header}
            {children}
          </>
        ) : (
          <Card>
            {header}
            <CardBody>{children}</CardBody>
          </Card>
        )}
      </GridContainer>
    </Box>
  );
};

export default PageLayout;
